import { render, staticRenderFns } from "./BPJSKaryawan.vue?vue&type=template&id=9dada60e"
import script from "./BPJSKaryawan.vue?vue&type=script&lang=js"
export * from "./BPJSKaryawan.vue?vue&type=script&lang=js"
import style0 from "./BPJSKaryawan.vue?vue&type=style&index=0&id=9dada60e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports